import React, { useState } from "react";
import { Button, CardBody, CardHeader, Col, Row } from "reactstrap";
import moment from "moment";
import l10n from "../../../../../../localization";
import Helpers from "../../../../../../helpers/helpers";
import InvoicePdf from "../../../InvoicePdf";
import MobileMeterInvoiceEntry from "../MobileMeterInvoiceEntry/MobileMeterInvoiceEntry";
import * as Styled from "./mobileInvoiceEntry.styles";

const MobileInvoiceEntry = (props) => {
  const [expanded, setExpanded] = useState(false);

  const { invoice } = props;
  if (!invoice) return;

  return (
    <Styled.Card>
      <CardHeader>
        <Row>
          <Col>
            <Styled.Month>
              {moment(invoice.invoiceIssueDate).format("MMMM YYYY")}
            </Styled.Month>
          </Col>
          <Col align={"right"}>
            {l10n.invoices.invoiceValueShort} {' '}
            <Styled.PriceTag status={invoice.isPayed}>
              <strong>
                {Helpers.formatPrice(
                  invoice.invoiceDebt > 0
                    ? invoice.invoiceDebt
                    : invoice.invoiceValue
                )}
              </strong>
            </Styled.PriceTag>
          </Col>
          {/* <Col>
            <Styled.PDFWrapper>
              <InvoicePdf
                handleOpenInvoice={() => props.onOpenInvoice(invoice.invoiceId)}
                downloading={invoice.downloadingPdf}
              />
            </Styled.PDFWrapper>
          </Col> */}
        </Row>
      </CardHeader>
      <CardBody>
        <Styled.InvoiceRow>
          <Col>
            <Styled.InvoiceRowKey>
              {l10n.invoices.meterLocation}
            </Styled.InvoiceRowKey>
            <Styled.InvoiceRowValue>
              {invoice.invoiceAddress}
            </Styled.InvoiceRowValue>
          </Col>
          <Col align="right">
            <Styled.InvoiceRowKey>{l10n.invoices.invoiceValue}</Styled.InvoiceRowKey>
            <Styled.InvoiceRowValue>
              {Helpers.formatPrice(invoice.invoiceValue)}
            </Styled.InvoiceRowValue>
          </Col>
        </Styled.InvoiceRow>
        <Styled.InvoiceRow>
          <Col>
            <Styled.InvoiceRowKey>
              {l10n.invoices.invoiceNumber}
            </Styled.InvoiceRowKey>
            <Styled.InvoiceRowValue>
              {invoice.invoiceNumber}
            </Styled.InvoiceRowValue>
          </Col>
          <Col align="right">
            <Styled.InvoiceRowKey>{l10n.invoices.invoiceBalance}</Styled.InvoiceRowKey>
            <Styled.InvoiceRowValue>
              {Helpers.formatPrice(invoice.invoiceBalance)}
            </Styled.InvoiceRowValue>
          </Col>
        </Styled.InvoiceRow>
        <Styled.InvoiceRow>
          <Col>
            <Styled.InvoiceRowKey>
              {l10n.invoices.invoiceType}
            </Styled.InvoiceRowKey>
            <Styled.InvoiceRowValue>
              {invoice.invoiceType}
            </Styled.InvoiceRowValue>
          </Col>
          <Col align="right">
            <Styled.InvoiceRowKey>{l10n.invoices.invoiceDebt}</Styled.InvoiceRowKey>
            <Styled.InvoiceRowValue>
              {Helpers.formatPrice(invoice.invoiceDebt)}
            </Styled.InvoiceRowValue>
          </Col>
        </Styled.InvoiceRow>
        <Styled.InvoiceRow>
          <Col>
            <Styled.InvoiceRowKey>{l10n.invoices.issueDate}</Styled.InvoiceRowKey>
            <Styled.InvoiceRowValue>
              {invoice.invoiceIssueDate ? moment(invoice.invoiceIssueDate).format("DD.MM.YYYY") : "-"}
            </Styled.InvoiceRowValue>
          </Col>
          <Col align="right">
            <Styled.InvoiceRowKey>{l10n.invoices.dueDate}</Styled.InvoiceRowKey>
            <Styled.InvoiceRowValue>
              {invoice.invoiceExpirationDate ? moment(invoice.invoiceExpirationDate).format("DD.MM.YYYY") : "-"}
            </Styled.InvoiceRowValue>
          </Col>
        </Styled.InvoiceRow>
        <Styled.InvoiceRow>
        <Col>
            <Styled.InvoiceRowKey>{l10n.invoices.period}</Styled.InvoiceRowKey>
            <Styled.InvoiceRowValue>
              {invoice.period ? moment(invoice.period).format("MM.YYYY") : "-"}
            </Styled.InvoiceRowValue>
          </Col>
          <Col>
            <Styled.PDFWrapper>
              <InvoicePdf
                handleOpenInvoice={() => props.onOpenInvoice(invoice.invoiceId)}
                downloading={invoice.downloadingPdf}
              />
            </Styled.PDFWrapper>
          </Col>
        </Styled.InvoiceRow>
        {invoice.isReversed && (
          <Styled.InvoiceRow>
            <Col>
              <Styled.InvoiceRowStatus>
                {l10n.einvoice.isReversed}
              </Styled.InvoiceRowStatus>
              <Styled.InvoiceRowValue></Styled.InvoiceRowValue>
            </Col>
          </Styled.InvoiceRow>
        )}

        {invoice.isEnforcement && (
          <Styled.InvoiceRow>
            <Col>
              <Styled.InvoiceRowStatus>
                {l10n.einvoice.isEnforcement}
              </Styled.InvoiceRowStatus>
              <Styled.InvoiceRowValue></Styled.InvoiceRowValue>
            </Col>
          </Styled.InvoiceRow>
        )}

        <Styled.ActionHolder>
          <Button color="link" onClick={() => setExpanded(!expanded)}>
            <Styled.MoreInfoWrapper>
              <p>{l10n.invoices.moreInfo}</p>
              <i className={`fas fa-chevron-${expanded ? "up" : "down"}`}></i>
            </Styled.MoreInfoWrapper>
          </Button>
        </Styled.ActionHolder>
        {expanded &&
          invoice.meters.map((meter) => (
            <MobileMeterInvoiceEntry key={meter.meterCode} meter={meter} />
          ))}
      </CardBody>
    </Styled.Card>
  );
};

export default MobileInvoiceEntry;
